import isString from "lodash/fp/isString";
import isNil from "lodash/fp/isNil";

class Controller {
  constructor($q, $injector, Events) {
    "ngInject";

    this.$q = $q;
    this.$injector = $injector;

    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }

  $onInit() {
    this.Resource = this.$injector.has(this.resource)
      ? this.$injector.get(this.resource)
      : {};
    this.maxSize = this.maxSize || "1MB";
  }

  enableDocument(document) {
    document.isDisabled = false;
  }

  isImageString(str) {
    return isString(str);
  }

  removeImage(images, index) {
    images.splice(index, 1);
  }

  uploadImage(document) {
    return this.Resource[this.uploadMethod || "uploadDocument"](
      { document },
      this.resourceId
    ).$promise.then(
      (response) => response.data,
      (response) => {
        this.Events.emit(this.errorNotificationEvent, response.data);
      }
    );
  }

  handleImageUrlSuccess(responses) {
    return responses.reduce((urls, currentData) => {
      if (!isNil(currentData) && !isNil(currentData.url)) {
        urls.push(currentData.url);
      }
      return urls;
    }, []);
  }

  onDocumentUpdate(document, holder, key) {
    if (document.isDisabled) {
      this.enableDocument(document);
    } else {
      document.images = document.images || [];
      const { text, images } = document;
      const actualImages = images.filter(isString);
      const newImages = images.filter((image) => !isString(image));
      const allUploadPromises = newImages.map(this.uploadImage.bind(this));
      this.$q.all([...allUploadPromises]).then((responses) => {
        const updatedDocument = {
          [holder]: {
            [key]: {
              text,
              images: [
                ...actualImages,
                ...this.handleImageUrlSuccess(responses),
              ],
            },
          },
        };
        this.Resource[this.updateMethod || "updateDocument"](
          updatedDocument,
          this.resourceId
        ).$promise.then(
          () => {
            document.isDisabled = true;
            this.Events.emit(this.successNotificationEvent, {
              message: "Document updated successfully",
            });
          },
          (response) => {
            this.Events.emit(this.errorNotificationEvent, response.data);
          }
        );
      });
    }
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableImageUploader/editableImageUploader.controller.js